import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name : 'PrdFilter'
})

export class PrdFilter implements PipeTransform{
    transform(products: any[], searchTerm : any): any{
        if(products==null || products==undefined){
            return null;
        }
        return products.filter(product=>{
            return (product.prd_code.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) ||
                   (product.prd_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
        });
    }
}


// WEBPACK FOOTER //
// ./src/filters/prdFilter.pipe.ts